import moment from "moment";
import { unparse as convertToCSV } from "papaparse/papaparse.min";
import { downloadCsv } from "../../utils";

export const exporter = (data) => {
  const dataForExport = data.map((item) => ({
    "Tipo de Documento": item.user?.typeUser.name,
    Documento: item.user?.document,
    "CPF": item.user?.cpf,
    "Origem do Endereço": item.sourceAddress?.name,
    CEP: item.cep,
    Endereço: item.address,
    Número: item.number,
    Complemento: item.complement,
    Bairro: item.district,
    Cidade: item.city,
    Estado: item.state,
    "Data de Criação": moment(item.createdAt).format("DD/MM/YYYY"),
    "Tipo de Endereço": item.typeAddress?.name || "",
    "Outro Tipo de Endereço": item.otherAddressType || "",
    "Entrega confirmada": item.statusDeliveryAddressId === 0 ? "Confirmada" : item.statusDeliveryAddressId === 1 ? "Devolvida" : "Não",
    "Alterado por": item.createdByUser?.email,
  }));

  const csv = convertToCSV(
    {
      data: dataForExport,
      fields: [
        "Tipo de Documento",
        "Documento",
        "CPF",
        "Origem do Endereço",
        "Endereço",
        "Número",
        "Complemento",
        "Bairro",
        "CEP",
        "Cidade",
        "Estado",
        "Data de Criação",
        "Tipo de Endereço",
        "Outro Tipo de Endereço",
        "Entrega confirmada",
        "Alterado por",
      ],
    },
    { delimiter: ";" }
  );

  downloadCsv(csv, "addresses");
};
